
































































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import { classPrintWorld } from '@/common/js/PrintWorld'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import UpdateBackOrderStatu from '@/store/entities/back-order-update-statu'
    import UpdateOderStatu from './update-order-statu.vue'
    import EditPackedStastus from './order-packed.vue'
    import moment from 'moment'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import { getLodop,demoDownloadPDF } from '@/common/js/LodopFuncs'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    import { Select } from '../../../types/iview/select';
    Vue.use(VueClipboard)


    class PageOrderRequest extends PageRequest {
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        EndTime?: Date;
        ReceivedBeginTime?: Date;
        ReceivedEndTime?: Date;
        selectShipmentEnd: string;
        OrderType?: number;
        PlatformType?: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.OrderType = 0;
            this.PlatformType = null;
        }
    }

    @Component({
        name: "backOrderList",
        components: { UpdateOderStatu, EditPackedStastus }
        
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        receivedTime: Date[] = [];
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        updateOderStatuShow = false;
        editModalShow: boolean = false;
        automaticJump: boolean = true;
        flag: boolean = false;
        orderNumberList: string[] = [];
        logisticsList: string[] = [];
        BaseSkuNums: number[] = [];
        isLoadPrintList: boolean = false;
        get list() {
            return this.$store.state.backorder.list;
        };
        get loading() {
            return this.$store.state.backorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backorder/setCurrentPage', page);
            this.getpage();
        }
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backorder/setPageSize', pagesize);
            this.getpage();
        }

        @Watch('$route.params.inputShipment')
        inputShipmentChange() {
            var s = '';
            if (this.$route.params.inputShipment) {
                this.pagerequest = new PageOrderRequest();
                this.pagerequest.SearchInfo = this.$route.params.inputShipment;
                this.$store.state.backorder.currentPage = 1;
                this.getpage();
            }

        }
        clearPageListChild(){
	       var PagSizeList =document.getElementById('SelectPrintPage'); 
	           while(PagSizeList.childNodes.length>0){
  		        var children = PagSizeList.childNodes;	
	  		    for(var i=0;i<children.length;i++){		
			    PagSizeList.removeChild(children[i]);	
	  	  };	   
	   };	   
        }



        printPdf(data) {

            if (!this.isLoadPrintList) {
                var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
                var json = {
                    action: "", refresh: true, defaultprn: true, error: "", val: {}
                };
                json.action = "printers";
                json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
                json.defaultprn = true;                   //是否包含缺省打印机信息。
                json = printWorld.Direct(json);
                if (json == null) {//数据发送失败
                    alert(printWorld.GetLastError());
                } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                    alert(json.error);
                } else {    //处理包含打印机列表的json
                }


                var Options = new Array();
                for (var i in json.val) {
                    var option = document.createElement('option');
                    option.innerHTML = json.val[i].name;
                    option.value = json.val[i].name;
                    document.getElementById('SelectPrint').appendChild(option);
                }
                this.isLoadPrintList = true;
                this.$Message.success("已加载打印机，请选择指定打印机");
                return;
            }


            var pdfData = {
                pdfGuid: data.pdfGuid,
                userId: data.userId,
                orderNumber: data.orderNumber,
                url: '',
            };
            this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);

            var printSelect: any = document.querySelector('#SelectPrint');
            if (!printSelect.value) {
                this.$Message.success("请选择指定打印机");
                return;
            }
            if (pdfData.url && pdfData.url.length > 0) {
                var printWorld = new classPrintWorld(); //new 一个打天下对象
                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                jsons.action = "printfile";
                jsons.format = "pdf_url";        //指定格式为pdf_url。
                jsons.content = pdfData.url;   //pdf文件的url路径
                jsons.paperlength = 10;
                jsons.paperwidth = 10;
                jsons.cert = "http://warehouse.ddtmx.com/cer/fileprintauth.ctf";
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                printWorld.Direct(jsons);
            }
        }

        //changePrint() {
        //    var printSelect: any = document.querySelector('#SelectPrint');
        //    if (printSelect.value) {
        //        var LODOP = getLodop();
	       //     this.clearPageListChild();
	       //     var strPageSizeList=LODOP.GET_PAGESIZES_LIST(printSelect.value,"\n");
	       //     var Options=new Array(); 
 	      //      Options=strPageSizeList.split("\n");       
	       //     for (var i in Options)    
	       //     {    
	       //         var option=document.createElement('option');   
		      //      option.innerHTML=Options[i];
		      //      option.value=Options[i];
   		   //         document.getElementById('SelectPrintPage').appendChild(option);
	       //     } 
        //    }
        //}
        //GetPrint() {
        //    var LODOP = getLodop();
        //    this.isLoadPrintList = true;
        //    var printSelect: any = document.querySelector('#SelectPrint');
        //    LODOP.Create_Printer_List(printSelect);
        //    this.$Message.success("已加载打印机，请选择指定打印机");
            
        //}


        //  printPdf(data) {
        //    var pdfData = {
        //        pdfGuid: data.pdfGuid,
        //        userId: data.userId,
        //        orderNumber: data.orderNumber,
        //        url: '',
        //    };
        //    this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);
        //    if (pdfData.url && pdfData.url.length > 0) {
        //        var LODOP = getLodop();
        //        if (!this.isLoadPrintList) {
        //            LODOP.Create_Printer_List(document.getElementById('SelectPrint'));
        //            this.$Message.success("已加载打印机，请选择指定打印机");
        //            this.isLoadPrintList = true;
        //            return;
        //        }
        //        var printSelect: any = document.querySelector('#SelectPrint');
        //        if (!printSelect.value) {
        //            this.$Message.success("请选择指定打印机");
        //            return;
        //        }
        //        LODOP.SET_PRINTER_INDEX(printSelect);
        //        LODOP.PRINT_INIT("订单" + data.orderNumber + "打印");
        //        if (pdfData.url.indexOf('https://') != -1) {
        //            var base64 = demoDownloadPDF(pdfData.url);
        //            LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", base64);
        //        } else {
        //             LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%",pdfData.url);
        //        }
        //        var pageSelect: any = document.querySelector("#SelectPrintPage");
        //        if (pageSelect.value) {
        //           LODOP.SET_PRINT_PAGESIZE(0,0,0,pageSelect.value);
        //        }
        //        LODOP.PRINT();
        //    }
        //}


       

        async weighing() {
            this.updatePackageStatus(3);
        }
        async cancelpacked() {
            this.updatePackageStatus(8);
        }
      


        async Newpacked(data: any) {
           
            //var selectionData: any = this.$refs.selection;
            //var selection = selectionData.getSelection();
            //if (!selection || selection.length == 0) {
            //    this.$Message.error("选中项不能为空！");
            //    return;
            //}
            var ids = [];
            var abnormalOrderList: any[] = [];
            //for (var i = 0; i < selection.length; i++) {

               
            //}

            for (var j = 0; j < data.logistics.length; j++) {
                if (data.logistics[j].orderCount > 1) {
                    this.logisticsList.push(data.logistics[j].shipment);
                }
            }
            //if (selection[i].productOrderStatus != 2) {
            //    this.orderNumberList.push(selection[i].orderNumber);

            if (data.productOrderStatus !== null && data.productOrderStatus !== undefined) {
                var statuName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                if (statuName != "待发货") {
                    this.orderNumberList.push(data.orderNumber);
                }
            }
            if (data.abnormalUserId) {
                abnormalOrderList.push({ orderNumber: data.orderNumber, abnormalUserId: data.abnormalUserId });
            }
            ids.push(data.id);

            this.$store.state.backorder.BaseSkuNums =data.orderProductInfoList.length;
            if (this.logisticsList.length > 0) {
                var _this = this;
                _this.$Modal.confirm({
                    title: "是否打包", content: "快递单号为【" + this.logisticsList + "】关联多个虾皮订单，是否继续标为已打包？", width: 800, onOk: async () => {
                        this.logisticsList = [];
                        setTimeout(() => {
                            _this.OrderNumberPrompt(ids,abnormalOrderList);
                        }, 500);

                    }, onCancel: () => {
                        this.logisticsList = [];
                    }
                });
            }
            else {
                this.OrderNumberPrompt(ids,abnormalOrderList);
            }
        }

        OrderNumberPrompt(ids: any[],abnormalOrderList:any[]) {
            var _this = this;
                if (_this.orderNumberList.length > 0) {
                    _this.$Modal.confirm({
                        title: "是否打包", content: "订单编号为【" + _this.orderNumberList + "】,产品订单状态不为【待发货】状态，是否继续标为已打包？", width: 800, onOk: () => {
                            _this.orderNumberList = [];
                            _this.ShowPacked(ids,abnormalOrderList);
                        }, onCancel: () => {
                            _this.orderNumberList = [];
                        }
                    });
                }
                else {
                    _this.ShowPacked(ids,abnormalOrderList);    
                }
        }
        

        async ShowPacked(ids: any[],abnormalOrderList:any[]) {
            this.$store.state.backorder.ids = ids;

            this.$store.state.backorder.ordertype = 0;
            this.$store.state.backorder.abnormalOrderList = abnormalOrderList;
            this.$store.state.backorder.automaticJump = this.automaticJump;
            this.editModalShow = true;
        }

        async arriveWarehouse() {
            this.updatePackageStatus(4);
        }

        async AllarriveWarehouse() {
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == 4 })[0].name;
            this.$Modal.confirm({
                title: "一键送仓", content: "确认批量将包裹状态处理为【" + statuName + "】？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backorder/oneClickDelivery',
                        data: { }
                    });
                    this.getpage();
                }
            });
            
        }

        async pendingWarehouse() {
            this.updatePackageStatus(6);
        }
        async updatePackageStatus(statu: number) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改包裹状态", content: "确认批量将此订单处理为" + statuName + "？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backorder/updatePackageStatus',
                        data: { ids: ids, PackageStatus: statu, orderType: this.pagerequest.OrderType }
                    });
                    this.getpage();

                }
            });
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            if (this.receivedTime.length > 0) {
                this.pagerequest.ReceivedBeginTime = this.receivedTime[0];
            } else {
                this.pagerequest.ReceivedBeginTime = null;
            }
            if (this.receivedTime.length > 1) {
                this.pagerequest.ReceivedEndTime = this.receivedTime[1];
            } else {
                this.pagerequest.ReceivedEndTime = null;
            }

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'backorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }

        async searchPage() {
            this.$store.state.backorder.currentPage = 1;
            this.getpage();
        }

        get pageSize() {
            return this.$store.state.backorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backorder.currentPage;
        }
        async operationData(name: any, data: any) {
            //if (name == '查看Pdf') {
            //    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
            //    if (packageStatus != "已收货") {
            //        this.$Modal.confirm({
            //            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
            //                this.$store.commit('fontorder/getPdf', {
            //                    pdfGuid: data.pdfGuid,
            //                    userId: data.userId,
            //                    orderNumber: data.orderNumber
            //                });
            //            }
            //        });
            //    }
            //    else {
            //        this.$store.commit('fontorder/getPdf', {
            //            pdfGuid: data.pdfGuid,
            //            userId: data.userId,
            //            orderNumber: data.orderNumber
            //        });
            //    }
              
           
            //} 
            if (name == "复制订单编号") {
                this.copyInfo(data.orderNumber);
            }
            else if (name == "复制快递单号") {
                var stringList: Array<string> = [];
                data.logistics.forEach(function (element) {
                    stringList.push(element.shipment);
                });
                this.copyInfo(stringList.join("/"));
            }
            else if (name == '标记为异常') {
                var updateData = new UpdateBackOrderStatu();
                updateData.id = data.id;
                updateData.orderStatus = -1;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                this.$store.state.backorder.updateOrdeData = updateData;

                this.updateOderStatuShow = true;
            } else if (name == '标记为正常') {
                var updateData = new UpdateBackOrderStatu();
                updateData.id = data.id;
                updateData.orderStatus = 0;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                updateData.abnormalImageUploadGuid = data.abnormalImageUploadGuid,
                this.$store.state.backorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            } else if (name == '撤销订单') {
                await this.$store.dispatch({
                    type: 'backorder/cancelOrder',
                    data: { id: data.id }
                });
                this.getpage();
            }
        }

        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }



        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
             
            },
            {
                title: '所属平台',
                width: 90,
                key: 'platformType',
                render: (h: any, params: any) => {
                    return h('span', Enums.PlatformType.filter(function (item) { return item.value == params.row.platformType })[0].name);
                }
            },
            {
                title: '用户编号',
                key: 'userCode',
                width: 90,
            },
            {
                title: '快递单号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        var productOrderStatusName = "";
                        if (params.row.productOrderStatus != null) {
                            productOrderStatusName = Enums.ProductOrderStatus.filter(function (dataItem) { return dataItem.value == params.row.productOrderStatus })[0].name;
                        }
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn || productOrderStatusName == "已取消" || packagestus=="已撤销") {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = "-" + item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span>' + shelfNumber + '</a>'
                            }
                        });
                    }));
                }
            },
        
            {
                title: '商品信息',
                width: 300,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
                    }));
                }
            },
            {

                title: '订单状态',
                width: 90,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            }, {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name,
                    )
                }
            }, {
                title: '客户备注',
                width: 150,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            },
            {
                title: '仓库备注',
                width: 150,
                key: 'warehouseReMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.warehouseReMark)]
                    )
                }
            },
            {
                title: '产品订单状态',
                width: 110,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: 'red' } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 90,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id + "%",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },{
                title: '接收时间',
                key: 'receivedTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.receivedTime ? DateUtils.formatLongDate(new Date(params.row.receivedTime)) : '');
                }
            }, {
                title: '创建时间',
                key: 'createTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },
            {
                title: '采购订单编号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        return h('li', {
                            domProps: {
                                innerHTML: '<span> ' + (item.purchaseOrderNumber ? item.purchaseOrderNumber : "") + ' </span>'
                            }
                        });
                    }));
                }
            },
            {
                title: '仓库名称',
                key: 'warehouseName',
                width: 130,
            },
             {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            },
            {
                title: '打包时间',
                key: 'packedTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.packedTime ? DateUtils.formatLongDate(new Date(params.row.packedTime)) : '');
                }
            }, {
                title: '称重时间',
                key: 'weighingTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.weighingTime ? DateUtils.formatLongDate(new Date(params.row.weighingTime)) : '');
                }
            },{
                title: '打包人',
                key: 'packedUserName',
                width: 80,
            }, {
                title: '异常人',
                key: 'abnormalUserName',
                width: 80,
            },
            {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },
            {
                title: '打包袋金额',
                key: 'sackTotalAmount',
                width: 80,
            },
            {
                title: 'SKU金额',
                key: 'skuTotalAmount',
                width: 80,
            },
          {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
              render: (h: any, params: any) => {
                  var data = params.row;
                  var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                  var productOrderStatusName = "";
                  if (data.productOrderStatus != null) {
                       productOrderStatusName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                  }
                  var orderStatus = Enums.WarehouseOrderStatus.filter(function (item) { return item.value == data.orderStatus })[0].name;
                    var _this = this;
                    var menu = [];
                    //if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                    //    menu.push("查看Pdf");
                    //}
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 5) {
                        menu.push("标记为异常");
                    }
                    if (params.row.orderStatus == -1 && params.row.packageStatus != 5) {
                        menu.push("标记为正常");
                    }
                    if ((params.row.packageStatus == 0 && params.row.orderStatus == 0) || params.row.orderStatus == -1) {
                        menu.push("撤销订单");
                    }
                    menu.push("复制订单编号");
                    if (params.row.logistics && params.row.logistics.length > 0) {
                        menu.push("复制快递单号");
                    }
               
                    return h('div', [
                        h('Dropdown', {
                        props: {
                            transfer: true,
                            trigger: 'click',
                        },
                        on: {
                            'on-click': (name) => {
                                _this.operationData(name, params.row);
                            }
                        }

                    }, [
                        h('Button',
                            {
                                domProps: {
                                    innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                },
                                props: {
                                    type: 'primary',
                                }

                            }),

                        h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                            return h('DropdownItem', { props: { name: item } }, item)
                        })
                        )],
                    ),
                         h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var _this = this;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "打印PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否打印此订单的面单？", onOk: async () => {
                                                //_this.printPdf(data);
                                                _this.printPdf(data);
                                            }
                                        });
                                    }
                                    else {
                                        _this.printPdf(data);
                                    }
                                }
                            }
                        }, "打印PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size:'small',
                            },
                            style: {
                                marginTop:'5px',
                                height: '30px',
                                width:'68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
                                                this.$store.commit('fontorder/getPdf', {
                                                    pdfGuid: data.pdfGuid,
                                                    userId: data.userId,
                                                    orderNumber: data.orderNumber
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        this.$store.commit('fontorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            userId: data.userId,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }
                           
                        }, "查看PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                                display: (packageStatus == "未收货" || packageStatus == "已收货" && orderStatus == "正常") && productOrderStatusName != "已取消"  ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.Newpacked(data);
                                }
                            }

                        }, "打包")
                    ]);
                }
            }]

        async created() {
            this.getpage();
           
        }
        async mounted() {
        }
    }
